var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97974 0.296509C1.42746 0.296509 0.979736 0.744235 0.979736 1.29651V21.2965C0.979736 21.8488 1.42746 22.2965 1.97974 22.2965H31.9797C32.532 22.2965 32.9797 21.8488 32.9797 21.2965V1.29651C32.9797 0.744235 32.532 0.296509 31.9797 0.296509H1.97974ZM30.9797 3.54595L23.4914 8.70979L27.6586 12.5622C28.0639 12.9369 28.0888 13.5701 27.7141 13.9753C27.3393 14.3806 26.7061 14.4055 26.3009 14.0308L21.8039 9.87344L19.3706 11.5514C17.9347 12.5427 16.0247 12.5427 14.5894 11.5518L12.1556 9.87344L7.65857 14.0308C7.25329 14.4055 6.6201 14.3806 6.24545 13.9753C5.87078 13.5701 5.89565 12.9369 6.3009 12.5622L10.4681 8.70979L2.97974 3.54595V20.2965H30.9797V3.54595ZM4.69089 2.29651L15.7252 9.90558C16.4786 10.4258 17.4808 10.4258 18.2343 9.90558L29.2687 2.29651H4.69089Z",
    fill: "var(--primary-text-color, #313639)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/Icon_mail.29b5a5c2.svg";
export { ForwardRef as ReactComponent };